import React from 'react';
import { browserHistory } from 'react-router';
import Toaster from 'toastr';
import ErrorLabel from '../../common/errorLabel';
import FloatInput from '../../common/floatInput';
import Progress from '../../common/progress';
import NetworkErrorDiv from '../../common/networkErrorDiv';
import RenderObjects from '../../common/ObjectRenderer';
import Messages from '../../../configurations/messages';
import Constants from '../../../configurations/constants';
import { permissioned } from '../../common/permissionedHoc';
import ArbiterApi from '../../../api/ArbiterApi';
import DisputesApi from '../../../api/DisputesApi';
import TransactionsApi from '../../../api/TransactionsApi';
import Util from '../../../util/util';
import RouteConfig from '../../../configurations/routesConfig';



class NewClaimModalContent extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            category: '',
            reasonCode: '',
            disputeAmountType: Constants.TRANSACTIONS_DISPUTE_AMOUNT_FULL,
            transaction: null,
            reasonCodes: [],
            currentDomains: null,
            domain: null,
            validity: {
                disputeAmount: -1,
                reasonCode: -1,
                disputeAmountType: -1,
                category: -1,
                domain: -1

            },
            loadingTransaction: 0,
            createAnother: false,
            disputeCategoryErrors: null
        };

        this.onDisputeCategoryChange = this.onDisputeCategoryChange.bind(this);
        this.onDisputeAmountChange = this.onDisputeAmountChange.bind(this);
        this.onSelectInputTypeChange = this.onSelectInputTypeChange.bind(this);
        this.onDisputeAmountTypeChange = this.onDisputeAmountTypeChange.bind(this);
        this.handleCreateDispute = this.handleCreateDispute.bind(this);
    }

    componentDidMount() {
        let transaction = this.props.transaction;
        if (this.props.isDisputeReOpen) { //A dispute recreation/reopen
            //use transaction property 
            this.setState({ transaction: transaction });
        }
        else {

            this.setState({ loadingTransaction: 1 });
            TransactionsApi
                .getTransaction(encodeURIComponent(transaction.transactionReference), transaction.transactionType)
                .then(response => {
                    let data = response.data;
                    data = {
                        ...data,
                        transactionDate: Util.toUserLocalTime(data.transactionDate)
                      }
                    this.setState({ loadingTransaction: 0, transaction: data });
                })
                .catch(error => {
                    this.setState({ loadingTransaction: 0, loadingDispute: -1 });
                    Util.errorMessageToast(Toaster, error.data,
                        [`${Messages.ERROR_TRANSACTION_FETCH}`]
                    );
                })

        }

    }

    handleCreateDispute(evt) {
        //TODO Validate Controls
        let categoryValid = this.state.category ? 1 : 0;
        let reasonCodeValid = this.state.reasonCode ? 1 : 0;
        let disputeAmountTypeValid = this.state.disputeAmountType ? 1 : 0;
        let domainValidity = this.state.currentDomains && this.state.domain ? 1 : (this.state.currentDomains) ? 0 : 1;
        let disputeAmountValid = 1
        if (this.state.disputeAmountType === Constants.TRANSACTIONS_DISPUTE_AMOUNT_PARTIAL) {
            disputeAmountValid = this.state.disputeAmount && Constants.REG_EXPR_VALID_AMOUNT.test(this.state.disputeAmount);

        }

        //If a control is invalid
        if (!categoryValid || !reasonCodeValid || !disputeAmountTypeValid || !disputeAmountValid || !domainValidity) {
            let validity = Util.clone(this.state.validity);
            validity.category = categoryValid;
            validity.reasonCode = reasonCodeValid;
            validity.disputeAmountType = disputeAmountTypeValid;
            validity.disputeAmount = disputeAmountValid;
            validity.domain = domainValidity;
            this.setState({ validity: validity });
            return;
        }

        this.setState({ loading: true });
        let params = {
            category: this.state.category,
            reasonCode: this.state.reasonCode,
            disputeAmountType: this.state.disputeAmountType,
            transactionType: this.state.transaction.transactionType,
            transactionReference: this.state.transaction.transactionReference,
            disputeAmount: this.state.disputeAmountType === Constants.TRANSACTIONS_DISPUTE_AMOUNT_PARTIAL ? this.state.disputeAmount : null
        };
        if (this.state.domain) {
            params.domain = this.state.domain;
        }

        let disputePromise;
        if (this.props.isDisputeReOpen) {
            params.action = Constants.DISPUTE_ACTION_REOPEN;
            disputePromise = DisputesApi.reOpenDispute(this.state.transaction.logCode, params);
        }
        else {
            disputePromise = DisputesApi.createDispute(params);
        }
        disputePromise.then((response) => {
            Toaster.success(`${response.data.logCode} - ${Messages.SUCCESS_DISPUTE_CREATION}`);
            this.setState({ loading: false });
            if (this.state.createAnother || this.props.isDisputeReOpen) //close modal for a re-open
                this.props.closeModal(evt, this.props.isDisputeReOpen);
            else
                browserHistory.push(RouteConfig.DISPUTES_ROUTE.path);
        })
            .catch((error) => {

                Util.errorMessageToast(Toaster, error.data, [`${Messages.ERROR_DISPUTE_CREATION} `]);
                this.setState({ loading: false });
            })
    }

    onDisputeCategoryChange(event) {
        let value = event.target.value;
        let stateUpdate = { currentDomains: null, reasonCodes: [], domain: null };
        
        let validity = Util.clone(this.state.validity);
        validity.category = value ? 1 : 0;
        stateUpdate.category =  value;
        stateUpdate.validity = validity;

        if (value && this.state.transaction.disputeDomains) {
            stateUpdate.currentDomains = this.state.transaction.disputeDomains[value];
        }
        if(value && this.state.transaction.disputeCategoryErrors){
            stateUpdate.disputeCategoryErrors =  this.state.transaction.disputeCategoryErrors[value];
            if(stateUpdate.disputeCategoryErrors){
                //Dispute errors exist for that category. No need to Fetch reason codes, update state and return 
                this.setState(stateUpdate);
                return;
            }
        }
        //Clear reason Codes and update current dispute domains
        this.setState(stateUpdate);
        //Fetch new ones
        if (value) {
            ArbiterApi
                .getReasonCodesByCategory(value)
                .then((response) => {
                    let reasonCodes = response.data;
                    this.setState({ reasonCodes: reasonCodes });
                })
                .catch((error) => {
                    Util.errorMessageToast(Toaster, error.data,
                        [`${Messages.ERROR_REASON_CODES}`]
                    );
                });

        }
        
    }
    onSelectInputTypeChange(event) {
        let value = event.target.value, name = event.target.name;
        let validity = Util.clone(this.state.validity);
        validity[name] = value ? 1 : 0;
        this.setState({ [name]: value, validity: validity });
    }
    onDisputeAmountTypeChange(event) {
        let value = event.target.value;
        let validity = Util.clone(this.state.validity);
        validity.disputeAmountType = value ? 1 : 0;

        //DispenseAmount not needed if not partial dispense
        if (value !== Constants.TRANSACTIONS_DISPUTE_AMOUNT_PARTIAL) {
            validity.disputeAmountType = -1;
        }
        this.setState({ disputeAmountType: value, validity: validity });
    }
    onDisputeAmountChange(event) {
        let val = event.target.value;
        let disputeAmountValid = (val && Constants.REG_EXPR_VALID_AMOUNT.test(val)) ? 1 : 0;
        let validity = Util.clone(this.state.validity);
        validity.disputeAmount = disputeAmountValid;
        this.setState({ disputeAmount: val, validity: validity })
    }

    render() {
        return (
            <div>
                {this.state.loadingTransaction === 1 &&
                    <Progress />
                }
                {this.state.loadingTransaction === -1 &&
                    <NetworkErrorDiv title="" description="" />
                }
                {this.state.transaction &&
                    <div>
                        <div className="mod-content">
                        <form>
                                <div className="row">
                                    <div className=" col-md-6">
                                        <div className="form-div">
                                            <label>Issuer :</label>
                                            <label>{this.state.transaction.issuer || "-"}</label>
                                        </div>
                                        <div className="form-div">
                                            <label>Issuer Country :</label>
                                            <label>{this.state.transaction.issuerCountry || "-"}</label>
                                        </div>
                                        <div className="form-div">
                                            <label>Acquirer :</label>
                                            <label>{this.state.transaction.acquirer || "-"}</label>
                                        </div>
                                        <div className="form-div">
                                            <label>Acquirer Country:</label>
                                            <label>{this.state.transaction.acquirerCountry || "-"}</label>
                                        </div>
                                        <div className="form-div">
                                            <label>Merchant :</label>
                                            <label>{this.state.transaction.merchant || "-"}</label>
                                        </div>
                                        <div className="form-div">
                                            <label>Merchant Country:</label>
                                            <label>{this.state.transaction.merchantCountry || "-"}</label>
                                        </div>
                                        <div className="form-div">
                                            <label>Merchant Type :</label>
                                            <label>{this.state.transaction.merchantType || "-"}</label>
                                        </div>
                                        <div className="form-div">
                                            <label>Merchant Ref. :</label>
                                            <label>{this.state.transaction.merchantReference || "-"}</label>
                                        </div>

                                        <div className="form-div">
                                            <label>Tran. Date :</label>
                                            <label>{this.state.transaction.transactionDate}</label>
                                        </div>
                                        <div className="form-div">
                                            <label>Tran. Type :</label>
                                            <label>{this.state.transaction.transactionType}</label>
                                        </div>
                                        <div className="form-div">
                                            <label>Tran. Amount :</label>
                                            <label>{this.state.transaction.transactionAmount ? `${this.state.transaction.transactionAmount}` : '-'}</label>
                                        </div>
                                        <div className="form-div">
                                            <label>Surcharge Amount. :</label>
                                            <label>{this.state.transaction.surchargeAmount ? `${this.state.transaction.surchargeAmount}` : "-"}</label>
                                        </div>
                                        <div className="form-div">
                                            <label>Settlement Amount :</label>
                                            <label>{this.state.transaction.settlementAmount ? `${this.state.transaction.settlementAmount}` : "-"}</label>
                                        </div>
                                        <div className="form-div">
                                            <label>Scheme Amount :</label>
                                            <label>{this.state.transaction.schemeAmount || "-"}</label>
                                        </div>
                                        <div className="form-div">
                                            <label>Tran. Ref. :</label>
                                            <label>{this.state.transaction.transactionReference || "-"}</label>
                                        </div>
                                        <div className="form-div">
                                            <label>Customer Ref. :</label>
                                            <label>{this.state.transaction.customerReference || "-"}</label>
                                        </div>


                                        <div className="form-div">
                                            <label>PAN :</label>
                                            <label>{this.state.transaction.pan || "-"}</label>
                                        </div>
                                        <div className="form-div">
                                            <label>Card Scheme :</label>
                                            <label>{this.state.transaction.cardScheme || "-"}</label>
                                        </div>

                                        <div className="form-div">
                                            <label>STAN :</label>
                                            <label>{this.state.transaction.stan || "-"}</label>
                                        </div>
                                        <div className="form-div">
                                            <label>Terminal Type :</label>
                                            <label>{this.state.transaction.terminalType || "-"}</label>
                                        </div>
                                        <div className="form-div">
                                            <label>Terminal ID :</label>
                                            <label>{this.state.transaction.terminalId || "-"}</label>
                                        </div>

                                    </div>
                                    <div className=" col-md-6">
                                        {
                                            this.props.isDisputeReOpen &&
                                            <div className="form-div">
                                                <label>Log Code : </label>
                                                <label>{this.state.transaction.logCode || "-"}</label>
                                            </div>
                                        }

                                        <div className="form-div">
                                            <label>Card Acceptor Code :</label>
                                            <label>{this.state.transaction.cardAcceptorCode || "-"}</label>
                                        </div>

                                        <div className="form-div">
                                            <label>Card Acceptor Loc. :</label>
                                            <label>{this.state.transaction.cardAcceptorLocation || "-"}</label>
                                        </div>


                                        <div className="form-div">
                                            <label>Response Code :</label>
                                            <label>{this.state.transaction.responseCode || "-"}</label>
                                        </div>

                                        <div className="form-div">
                                            <label>Response Desc. :</label>
                                            <label>{this.state.transaction.responseDescription || "-"}</label>
                                        </div>

                                        <div className="form-div">
                                            <label>Settled :</label>
                                            <label>{this.state.transaction.settled == null ? "-" : `${this.state.transaction.settled ? 'Yes' : 'No'}`}</label>
                                        </div>
                                        <div className="form-div">
                                            <label>Dispute Region :</label>
                                            <label>{this.state.transaction.region || "-"}</label>
                                        </div>
                                        <div className="form-div">
                                            <label>Additional Info :</label>
                                            <div className="panel panel-default additional-info-panel" style={{width: "100%"}}>
                                                <div className="panel-body">
                                                    {
                                                        this.state.transaction.additionalInfo && 
                                                        <RenderObjects className="dispute-col" objectToConv={this.state.transaction.additionalInfo} />
                                                    }
                                                </div>
                                            </div>
                                            {/* <textarea readOnly="true"  style={{ width: "97%", height: "130px", fontSize: "12px" }} value={JSON.stringify(this.state.transaction.additionalInfo, null, 2)} /> */}
                                        </div>

                                        {
                                            this.state.transaction.disputeCategories && this.state.transaction.disputeCategories.length !== 0 &&
                                            < div id="categorySection">

                                                <div className="form-div">
                                                    <label className="required">Dispute Amount Type :</label>
                                                    <div>
                                                        <select
                                                            name="disputeAmountType"
                                                            id="disputeAmountType"
                                                            value={this.state.disputeAmountType}
                                                            onChange={this.onDisputeAmountTypeChange}
                                                        >
                                                            <option selected={true} value={Constants.TRANSACTIONS_DISPUTE_AMOUNT_FULL}>{Constants.TRANSACTIONS_DISPUTE_AMOUNT_FULL}</option>
                                                            <option value={Constants.TRANSACTIONS_DISPUTE_AMOUNT_PARTIAL}>{Constants.TRANSACTIONS_DISPUTE_AMOUNT_PARTIAL}</option>
                                                        </select>
                                                        {
                                                            (this.state.validity.disputeAmountType === 0) &&
                                                            <ErrorLabel message={Messages.INVALID_DISPUTE_AMOUNT_TYPE} />
                                                        }
                                                    </div>
                                                </div>
                                                {this.state.disputeAmountType !== Constants.TRANSACTIONS_DISPUTE_AMOUNT_FULL &&
                                                    <div className="form-div">
                                                        <label  className="required">Dispute Amount.</label>
                                                        <FloatInput
                                                            id="disputeAmount"
                                                            value={this.state.disputeAmount}
                                                            onChange={this.onDisputeAmountChange}
                                                            placeholder="Enter amount"
                                                            showError={!this.state.validity.disputeAmount} errorMessage={`${Messages.INVALID_REQUESTED_AMOUNT}`} />

                                                    </div>
                                                }
                                                < div className="form-div">
                                                    <label className="required">Dispute Category</label>
                                                    <div>
                                                        <select
                                                            name="category"
                                                            id="category"
                                                            value={this.state.category}
                                                            onChange={this.onDisputeCategoryChange}
                                                        >
                                                            <option value="">--- Select ---</option>
                                                            {this.state.transaction.disputeCategories.map(category => {
                                                                return (<option key={category} value={category}>{category}</option>);
                                                            })}
                                                        </select>
                                                        {
                                                            (this.state.validity.category === 0) && !this.state.transaction.transactionErrors &&
                                                            <ErrorLabel message={Messages.INVALID_DISPUTE_CATEGORY} />
                                                        }
                                                    </div>
                                                </div>
                                                {
                                                    this.state.disputeCategoryErrors && this.state.category && <ErrorSection title="Dispute Error(s)" errors={this.state.disputeCategoryErrors} />
                                                }
                                                {
                                                    !this.state.disputeCategoryErrors && !this.state.transaction.transactionErrors && this.state.currentDomains && <div className="form-div">
                                                    <label className="required">Dispute Domain</label>
                                                    <div>
                                                        <select
                                                            name="domain"
                                                            id="domain"
                                                            value={this.state.domain}
                                                            required={true}
                                                            onChange={this.onSelectInputTypeChange}
                                                        >
                                                            <option value="">--- Select ---</option>
                                                            {
                                                                this.state.currentDomains.map((val) => { return (<option key={val} value={val}>{val}</option>) })
                                                            }
                                                        </select>
                                                        {
                                                            (this.state.validity.domain === 0) &&
                                                            <ErrorLabel message={Messages.INVALID_DOMAIN} />
                                                        }
                                                    </div>
                                                </div>
                                                }
                                                { !this.state.disputeCategoryErrors && !this.state.transaction.transactionErrors &&
                                                 <div className="form-div">
                                                    <label className="required">Reason</label>
                                                    <div>
                                                        <select
                                                            name="reasonCode"
                                                            id="reasonCode"

                                                            value={this.state.reasonCode}
                                                            required={true}
                                                            onChange={this.onSelectInputTypeChange}
                                                        >
                                                            <option value="">--- Select ---</option>
                                                            {
                                                                this.state.reasonCodes.map((val) => { return (<option key={val.code} value={val.code}>{val.name}</option>) })
                                                            }
                                                        </select>
                                                        {
                                                            (this.state.validity.reasonCode === 0) &&
                                                            <ErrorLabel message={Messages.INVALID_REASON_CODE} />
                                                        }
                                                    </div>
                                                </div>
                                                }
                                            </div>

                                        }

                                        {this.state.transaction.transactionErrors && this.state.transaction.disputeCategories && !this.state.category  &&
                                            <ErrorSection title="Dispute Error(s)" errors={this.state.transaction.transactionErrors} />
                                        }
                                        {this.state.transaction.transactionErrors && !this.state.transaction.disputeCategories &&
                                            <ErrorSection title="Transaction Error(s)" errors={this.state.transaction.transactionErrors} />
                                        }
                                    </div>
                                </div>
                            </form>
                        </div>

                        <div className="mod-footer" style={{ 'clear': 'both' }}>
                            {!this.state.disputeCategoryErrors && !this.state.transaction.transactionErrors &&  this.state.transaction.disputeCategories && this.state.transaction.disputeCategories.length !== 0 && !this.props.isDisputeReOpen &&
                                <div className="checkbox">
                                    <label>
                                        <input type="checkbox" checked={this.state.createAnother} onChange={(event) => { this.setState({ createAnother: event.target.checked }) }} />
                                        <span className="lbl"> Create Another</span>
                                    </label>
                                </div>
                            }
                            <div className="mod-footer-buttons" >
                                {!this.state.disputeCategoryErrors && !this.state.transaction.transactionErrors && this.state.transaction.disputeCategories && this.state.transaction.disputeCategories.length !== 0 &&
                                    <button onClick={this.handleCreateDispute} disabled={!this.isFormValid() || this.state.loading} className="btn btn-primary">CREATE</button>
                                 }
                                <button onClick={this.props.closeModal} disabled={this.state.loading} className="btn btn-danger">CLOSE</button>
                            </div>

                        </div>
                    </div>
                }
            </div>
        )
    }

    isFormValid() {
        let valid = true;
        for (let key in this.state.validity) {
            valid = valid && (this.state.validity[key] !== 0);
        }
        return valid;
    }
}

const ErrorSection = (props) => {
    return (
        <div className="form-div">
            <label>{props.title} :</label>
            <ul style={{ "border": "1px solid red", "width": "97%", "padding": "2%", "fontSize": "0.9em" }}>
                {
                    props.errors.map((item) =>
                        <li style={{ "listStyle": "disc", "marginLeft": "3%" }} key={item}>{item}</li>
                    )
                }
            </ul>
        </div>
    )
}

export default permissioned(NewClaimModalContent);


// WEBPACK FOOTER //
// ./src/components/disputeMgmt/newClaim/newClaimModalContent.js